export const translations = {
  en: {
    nav: {
      features: "Features",
      howItWorks: "How it Works",
      pricing: "Pricing",
      faq: "FAQ",
      contact: "Contact",
      login: "Login",
    },
    hero: {
      eyebrow: "BUILT FOR INDIAN SHOP OWNERS",
      title: "Know who owes you. Know who to pay.",
      titleHighlight: "Right on your phone.",
      subtitle:
        "Upload your Tally, Busy, Marg or Zoho PDF. Get Easy Statement instantly extracts every debtor and creditor — so you can manage payments even when your accountant isn't around.",
      ctaPrimary: "Get Free Demo",
      ctaSecondary: "Sign In",
      stat1: "5,000+ Shops",
      stat2: "Tally · Busy · Marg · Zoho",
      stat3: "PDF in — Clarity out",
    },
    how: {
      eyebrow: "HOW IT WORKS",
      title: "Three steps. One source of truth.",
      step1Title: "01 · Upload PDF",
      step1Desc:
        "Export ledger PDF from Tally, Busy, Marg ERP, Zoho or your local accounting software.",
      step2Title: "02 · We Extract",
      step2Desc:
        "Get Easy Statement reads every entry and organises debtors & creditors party-wise.",
      step3Title: "03 · Pay & Collect",
      step3Desc:
        "See per-party balances. Set reminders. Never miss a collection or payment again.",
    },
    features: {
      eyebrow: "BUILT FOR REAL SHOPS",
      title: "Everything a shop owner actually needs.",
      f1Title: "Party-wise Ledger",
      f1Desc:
        "See exactly how much you owe XYZ Company and how much ABC Traders owes you — one tap, single screen.",
      f2Title: "Smart Reminders",
      f2Desc:
        "Schedule reminders for payments to make and receivables to collect. Never miss a date.",
      f3Title: "PDF Upload & Auto-extract",
      f3Desc:
        "Works with Tally, Busy, Marg, Zoho and most local software. Just upload — we do the rest.",
      f4Title: "Team Roles",
      f4Desc:
        "Add up to 5 members. Assign roles — Accountant, Manager, Sales. Owner stays in control.",
      f5Title: "Owner-only Settings",
      f5Desc:
        "Only the shop owner can change payment options, permissions and core settings.",
      f6Title: "Works When Accountant Isn't",
      f6Desc:
        "Don't wait for your accountant. Check balances and make decisions in seconds.",
    },
    testimonials: {
      eyebrow: "WHAT SHOP OWNERS SAY",
      title: "Trusted by traders across India.",
      t1: "Pehle Tally dekhne ke liye accountant ka wait karna padta tha. Ab phone pe sab clear hai.",
      t1Author: "Rakesh Patel",
      t1Role: "Wholesaler, Ahmedabad",
      t2: "Reminder feature ne mera ₹2 lakh ka recovery time pe karwa diya. Worth every rupee.",
      t2Author: "Suresh Kumar",
      t2Role: "Kirana Distributor, Indore",
      t3: "Team roles set karke main apne sales boys ko sirf collection visibility deta hoon. Simple.",
      t3Author: "Mahesh Agrawal",
      t3Role: "Agri Trader, Nagpur",
    },
    faq: {
      eyebrow: "QUESTIONS",
      title: "Everything you wanted to ask.",
      q1: "Which accounting software does it support?",
      a1: "Tally, Busy, Marg ERP, Zoho Books and most local accounting software that can export ledger PDFs.",
      q2: "Is my data secure?",
      a2: "Yes. Your data is encrypted in transit and stored securely. Only your team members with permission can access it.",
      q3: "How many team members can I add?",
      a3: "Up to 5 members per account with roles like Accountant, Manager and Sales Person. Only the owner can change settings.",
      q4: "Do I need to be tech-savvy to use it?",
      a4: "No. If you can upload a PDF from WhatsApp, you can use Get Easy Statement. The interface is built for shop owners, not engineers.",
      q5: "Can I try before I subscribe?",
      a5: "Yes. Fill the enquiry form and we'll set up a free demo for your shop.",
    },
    pricing: {
      eyebrow: "PRICING",
      title: "Simple plans. Honest value.",
      subtitle:
        "We keep pricing transparent and friendly for small and mid-sized shops. Reach out and we'll share a plan that fits your business.",
      cta: "Contact us for pricing",
    },
    comingSoon: {
      badge: "COMING SOON",
      title: "Bulk invoice upload — auto-grouped by customer.",
      subtitle:
        "Drop hundreds of invoices in one go. Get Easy Statement will read each invoice and group them under the right customer automatically — no manual sorting.",
      b1: "Upload 100s of invoice PDFs in one shot",
      b2: "Auto-extracts customer name, amount, date from every invoice",
      b3: "Groups invoices customer-wise — see all bills for one party at a glance",
      cta: "Get notified at launch",
      previewLabel: "PREVIEW · CUSTOMER-WISE GROUPING",
      invoices: "invoices",
    },
    inquiry: {
      eyebrow: "GET IN TOUCH",
      title: "Tell us about your shop.",
      subtitle:
        "Fill the form below. We'll call you within one business day to set up a free demo.",
      name: "Your Name",
      shopName: "Shop / Business Name",
      phone: "Phone Number",
      email: "Email Address",
      software: "Which accounting software do you use?",
      softwarePlaceholder: "Select software",
      message: "Anything else? (optional)",
      messagePlaceholder: "Tell us about your needs...",
      submit: "Submit Enquiry",
      submitting: "Submitting...",
      success: "Thank you! We'll get in touch within one business day.",
      error: "Something went wrong. Please try again or call us.",
    },
    footer: {
      tagline: "Smart debtor & creditor management for Indian shop owners.",
      product: "Product",
      company: "Company",
      legal: "Legal",
      copyright: "© 2026 Flame Enterprises. All rights reserved.",
    },
    admin: {
      title: "Inquiry Inbox",
      subtitle: "All customer enquiries from the website.",
      tokenLabel: "Admin Token",
      tokenPlaceholder: "Enter admin token",
      login: "Sign In",
      logout: "Sign Out",
      total: "Total",
      new: "New",
      contacted: "Contacted",
      closed: "Closed",
      noInquiries: "No inquiries yet.",
    },
  },
  hi: {
    nav: {
      features: "विशेषताएँ",
      howItWorks: "कैसे काम करता है",
      pricing: "मूल्य",
      faq: "सामान्य प्रश्न",
      contact: "संपर्क",
      login: "लॉगिन",
    },
    hero: {
      eyebrow: "भारतीय व्यापारियों के लिए बनाया गया",
      title: "किसने आपका पैसा देना है। किसे आपने देना है।",
      titleHighlight: "सब आपके फोन पर।",
      subtitle:
        "अपनी Tally, Busy, Marg या Zoho की PDF अपलोड करें। Get Easy Statement हर देनदार-लेनदार का डेटा निकाल देगा — accountant के बिना भी सब क्लियर।",
      ctaPrimary: "फ्री डेमो लें",
      ctaSecondary: "साइन इन",
      stat1: "5,000+ दुकानें",
      stat2: "Tally · Busy · Marg · Zoho",
      stat3: "PDF अंदर — हिसाब बाहर",
    },
    how: {
      eyebrow: "कैसे काम करता है",
      title: "तीन कदम। एक सच।",
      step1Title: "01 · PDF अपलोड करें",
      step1Desc:
        "Tally, Busy, Marg ERP, Zoho या लोकल सॉफ्टवेयर से ledger PDF एक्सपोर्ट करें।",
      step2Title: "02 · हम निकालते हैं",
      step2Desc:
        "Get Easy Statement हर एंट्री पढ़कर party-wise देनदार-लेनदार सेट करता है।",
      step3Title: "03 · दें और लें",
      step3Desc:
        "Party-wise बैलेंस देखें। Reminder लगाएं। कोई collection miss नहीं।",
    },
    features: {
      eyebrow: "असली दुकानों के लिए",
      title: "जो दुकानदार को सच में चाहिए।",
      f1Title: "Party-wise खाता",
      f1Desc:
        "XYZ कंपनी को कितना देना है, ABC ने कितना देना है — एक स्क्रीन पर।",
      f2Title: "स्मार्ट Reminder",
      f2Desc:
        "Payment और recovery दोनों के लिए reminder लगाएं। तारीख़ कभी miss नहीं।",
      f3Title: "PDF अपलोड और ऑटो-एक्सट्रैक्ट",
      f3Desc:
        "Tally, Busy, Marg, Zoho सबके साथ काम करता है। बस PDF दें।",
      f4Title: "Team Roles",
      f4Desc:
        "5 लोग जोड़ें। Accountant, Manager, Sales — सबको अपना role।",
      f5Title: "केवल Owner की settings",
      f5Desc:
        "Payment options और permissions सिर्फ owner बदल सकता है।",
      f6Title: "Accountant के बिना भी",
      f6Desc:
        "Accountant का wait नहीं। बैलेंस देखें, फैसला लें — तुरंत।",
    },
    testimonials: {
      eyebrow: "दुकानदार क्या कहते हैं",
      title: "भारत के व्यापारियों का भरोसा।",
      t1: "पहले Tally देखने के लिए accountant का wait करना पड़ता था। अब phone पे सब clear है।",
      t1Author: "राकेश पटेल",
      t1Role: "होलसेलर, अहमदाबाद",
      t2: "Reminder feature ने मेरा ₹2 लाख का recovery time पर करवा दिया।",
      t2Author: "सुरेश कुमार",
      t2Role: "किराना डिस्ट्रिब्यूटर, इंदौर",
      t3: "Team roles सेट करके मैं sales boys को सिर्फ collection visibility देता हूँ।",
      t3Author: "महेश अग्रवाल",
      t3Role: "कृषि व्यापारी, नागपुर",
    },
    faq: {
      eyebrow: "प्रश्न",
      title: "जो आप पूछना चाहते थे।",
      q1: "कौन सा accounting software support होता है?",
      a1: "Tally, Busy, Marg ERP, Zoho Books और लगभग सभी लोकल सॉफ्टवेयर जो ledger PDF देते हैं।",
      q2: "क्या मेरा डेटा सुरक्षित है?",
      a2: "हाँ, डेटा encrypted है और केवल आपकी team देख सकती है।",
      q3: "कितने team members add कर सकते हैं?",
      a3: "एक अकाउंट में 5 लोग — Accountant, Manager, Sales roles के साथ। Settings सिर्फ owner change करता है।",
      q4: "क्या इसे इस्तेमाल करने के लिए technical होना ज़रूरी है?",
      a4: "नहीं। अगर आप WhatsApp पर PDF भेज सकते हैं, तो Get Easy Statement चला सकते हैं।",
      q5: "क्या मैं subscribe करने से पहले try कर सकता हूँ?",
      a5: "हाँ। Enquiry form भरें — हम free demo set करेंगे।",
    },
    pricing: {
      eyebrow: "मूल्य",
      title: "सरल प्लान। सही दाम।",
      subtitle:
        "हम छोटे और मंझले दुकानदारों के लिए ईमानदार pricing रखते हैं। संपर्क करें — हम आपके business के लिए सही plan बताएँगे।",
      cta: "मूल्य के लिए संपर्क करें",
    },
    comingSoon: {
      badge: "जल्द आ रहा है",
      title: "बल्क Invoice अपलोड — customer के हिसाब से auto-group।",
      subtitle:
        "एक साथ सैकड़ों invoices डालें। Get Easy Statement हर invoice पढ़कर सही customer के नीचे लगा देगा — manual sorting की ज़रूरत नहीं।",
      b1: "एक बार में 100+ invoice PDFs अपलोड करें",
      b2: "हर invoice से customer name, amount, date auto-निकलेगा",
      b3: "Party-wise group — एक customer के सभी bills एक जगह",
      cta: "Launch पर सूचित करें",
      previewLabel: "PREVIEW · CUSTOMER-WISE ग्रुपिंग",
      invoices: "invoices",
    },
    inquiry: {
      eyebrow: "संपर्क करें",
      title: "अपनी दुकान के बारे में बताएँ।",
      subtitle:
        "नीचे form भरें। हम एक business day में call करके free demo set करेंगे।",
      name: "आपका नाम",
      shopName: "दुकान / Business का नाम",
      phone: "फोन नंबर",
      email: "ईमेल पता",
      software: "कौन सा accounting software इस्तेमाल करते हैं?",
      softwarePlaceholder: "सॉफ्टवेयर चुनें",
      message: "और कुछ? (optional)",
      messagePlaceholder: "अपनी ज़रूरत बताएँ...",
      submit: "Enquiry भेजें",
      submitting: "भेज रहे हैं...",
      success: "धन्यवाद! हम एक business day में संपर्क करेंगे।",
      error: "कुछ गलत हुआ। फिर try करें।",
    },
    footer: {
      tagline: "भारतीय दुकानदारों के लिए स्मार्ट देनदार-लेनदार व्यवस्था।",
      product: "Product",
      company: "Company",
      legal: "Legal",
      copyright: "© 2026 Flame Enterprises. सर्वाधिकार सुरक्षित।",
    },
    admin: {
      title: "Inquiry Inbox",
      subtitle: "वेबसाइट से सभी customer enquiries।",
      tokenLabel: "Admin Token",
      tokenPlaceholder: "Admin token डालें",
      login: "साइन इन",
      logout: "साइन आउट",
      total: "कुल",
      new: "नए",
      contacted: "संपर्क हुआ",
      closed: "बंद",
      noInquiries: "अभी कोई enquiry नहीं।",
    },
  },
};
